<ion-header class="ion-no-border" mode="md">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>Zeit eintragen</ion-title>
    <ion-buttons slot="end" *ngIf="editMode">
      <ion-button style="box-shadow: none;" (click)="deleteTime()">
        <ion-icon name="fa-trash" color="red"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content NoScrollbar [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">
  <div class="at-items">
    <ion-item>
      <ion-label>Tätigkeit</ion-label>
      <div class="filter-bttn" (click)="selectTask($event)">
        {{activeTask.description}}
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" class="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
      </div>
    </ion-item>
    <ion-item>
      <ion-label>Datum:</ion-label>
      <input type="date" [ngModel]="date | date:'yyyy-MM-dd'" [value]="date | date:'yyyy-MM-dd'" (ngModelChange)="date = $event">
    </ion-item>
    <ion-item>
      <ion-label>Von:</ion-label>
      <input type="time" [ngModel]="von | date:'HH:mm'" [value]="von | date:'HH:mm'" (ngModelChange)="setFromOrTo($event, 'from')">
    </ion-item>
    <ion-item>
      <ion-label>Bis:</ion-label>
      <input type="time" [ngModel]="bis | date:'HH:mm'" [value]="bis | date:'HH:mm'" (ngModelChange)="setFromOrTo($event, 'to')">
    </ion-item>
    <ion-item>
      <div id="note">
        <ion-label style="padding-top: 0;">Notiz:</ion-label>
        <textarea placeholder="Notiz..." [(ngModel)]="note"></textarea>
      </div>
    </ion-item>
  </div>
</ion-content>

<ion-footer>
  <div class="button main-button" (click)="save()">
    Speichern
  </div>
</ion-footer>
